<template>
<div
  class="card-item-new"
  :class="{
    pointer: isSelectMode == true
  }"
  @click.stop="selectHandle"
>
<!--  <a
    :href="itemData.content.newsItem[0].url"
    class="article-item"
    target="_blank"
  >
    <el-image
      class="img-el"
      :src="itemData.content.newsItem[0].thumbUrl"
      fit="contain"
    ></el-image>
  </a>-->
  <h3 class="title line-text-flow">{{itemData.content.newsItem[0].title}}&nbsp;</h3>
  <div class="date">{{parseTime(itemData.updateTime)}}</div>
  <div class="align-center btn-modules" v-show="!isSelectMode">

    <el-button
      type="text"
      @click="onCopySuccess"
    >复制media_id</el-button>
    <el-button
      v-if="isAuth('wx:wxassets:save')"
      type="text"
      @click="editHandle"
    >编辑</el-button>
    <el-button
      type="text"
      v-if="isAuth('wx:wxassets:delete')"
      class="delete-btn"
      @click="deleteHandle(itemData.mediaId)"
    >删除</el-button>
  </div>
</div>
</template>

<script>
import copy from 'copy-to-clipboard';
import { parseTime } from "@/utils";

export default {
  name: "cardItemNew",
  props: {
    fileType: {
      type: String,
      default: 'image',
    },
    itemData: {
      type: Object,
      default(){
        return {}
      }
    },
    isSelectMode:{
      type: Boolean,
      default: false
    }
  },
  methods: {
    parseTime,
    selectHandle(){
      this.$emit('selected', this.itemData);
    },
    onCopySuccess(){
      copy(this.itemData.mediaId);
      this.$message.success('已复制')
    },
    onCopyError(err){
      this.$message.error('复制失败,可能是此浏览器不支持复制')
    },
    //删除
    deleteHandle(id) {
      this.$confirm(`确定对[mediaId=${id}]进行删除操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: 'wx/manage/wxAssets/materialDelete',
          method: 'post',
          data: { mediaId: id,type: 2 }
        }).then((data) => {
          if (data && data.code === 200) {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1500,
              onClose: () =>  {
                this.$emit('delete-success');
              }
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      })
    },
    editHandle(){
      this.$emit('edit',this.itemData);
    }
  },
}
</script>

<style lang="scss">
.card-item-new {

  padding-top: 10px;
  border: 1px solid #E0E4F2;
  border-radius: 10px;
  margin-bottom: 10px;
  .img-el {
    width: 100%;
    /*max-height: 170px;
    width: 100%;*/
  }
  .card-preview {
    background-color: #EFF3FF;
    color: #B7B8C9;
    padding: 5px;
    margin-bottom: 10px;
    .article-item {

      display: block;
      .article-thumb {
        width: 100%;
      }
    }
    .icon-inner {
      font-size: 30px;
    }
    .card-preview-text {
      margin-left: 10px;
    }
  }

  &.pointer {
    .article-item {
      pointer-events: none;
    }
  }

  .title,
  .date,
  .btn-modules {
    padding: 0 10px;
  }
  .btn-modules {
    flex-wrap: wrap;
    font-size: 18px;
    justify-content: space-around;
    //padding: 0 5px;
  }
  .title {
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 10px;
    word-break: break-word;
    white-space:nowrap;
  }
  .date {
    color: #B7B8C9;
    font-size: 12px;
  }

}
</style>
